import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { BottomHeroSection } from 'pages/home-page/sections/bottom-hero/BottomHeroSection'

interface SdkDownloadBottomHeroCmsContent {
  titleLine1: string
  titleLine2?: string
  buttonText: string
  buttonUrl: string
}

interface SDKDownloadBottomHeroProps {
  sdkName?: string
  content?: SdkDownloadBottomHeroCmsContent
}

export const SDKDownloadBottomHero: FC<SDKDownloadBottomHeroProps> = ({ sdkName, content }) => {
  const navigate = useNavigate()
  const title = content? (
    <>
      {content.titleLine1}
      {content.titleLine2 && (
        <>
          <br />
          {content.titleLine2}
        </>
      )}
    </>
  ): (
    <>
        Get Started with the <br /> {sdkName} SDK
    </>
  )

  return (
    <BottomHeroSection
      title={title}
      buttonText={content?.buttonText ?? 'Download the SDK'}
      buttonHref={content?.buttonUrl}
      buttonOnClick={content ? undefined : () => navigate('/resources')}
    />
  )
}
